module.exports = __webpack_public_path__ + "static/media/myneflix1.3003a291.gif";